import { render, staticRenderFns } from "./ProjectSite.vue?vue&type=template&id=195b2b3e&scoped=true"
import script from "./ProjectSite.vue?vue&type=script&lang=js"
export * from "./ProjectSite.vue?vue&type=script&lang=js"
import style0 from "./ProjectSite.vue?vue&type=style&index=0&id=195b2b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b2b3e",
  null
  
)

export default component.exports